/* ====================================================================== */
/* Bildkacheln, Bestsellerband und Aufpreis im TeeInBlue-Personalisierer  */
/* ====================================================================== */
/*
  Drei Aufgaben, ein Beobachter - alle betreffen dieselben Kacheln, und die
  App baut sie bei jeder Auswahl neu auf:

    1. Bildkacheln fuer die Ausfuehrungsauswahl (unten ausfuehrlich)
    2. das Eckband "Bestseller": die Kacheln, deren Wert im Feld
       configurator_bestseller steht, bekommen die Klasse paws-tib-bs. Das
       Band selbst ist ein ::after in assets/tib-variant-tiles.css - ein
       eingefuegter Knoten wuerde beim naechsten Neuaufbau verschwinden.
       Beide Datensaetze kommen als data-Attribut am <script>-Tag an, siehe
       snippets/tib-variant-tiles.liquid.
    3. der Differenzbetrag auf den Groessenkacheln ("+ 20 EUR") - dieselbe
       Angabe, die der eigene Konfigurator dort zeigt. Sie braucht keine
       Pflegedaten, sondern rechnet aus den Varianten im Formular.

  --- 1. Bildkacheln fuer die Ausfuehrungsauswahl ---

  TeeInBlue zeigt "Verfuegbare Produkte" (Poster / Leinwand) als reine
  Textradios. Der eigene Konfigurator zeigt an derselben Stelle Bildkacheln -
  und genau die sollen hier auch stehen, aus derselben Quelle gepflegt.

  Grundregel: wir fassen NICHTS an, was in den Warenkorb geht. Das <input>,
  sein value, seine id und die for-Beziehung des Labels bleiben unveraendert.
  Ergaenzt wird ausschliesslich ein <img> INNERHALB des vorhandenen Labels.
  Damit bleibt jede Auswahl-, Preis- und Warenkorblogik der App unberuehrt -
  ein neu gebautes Markup haette genau das riskiert.

  TeeInBlue ist eine Vue-Anwendung und baut den Block bei jeder Auswahl neu
  auf. Deshalb ein Beobachter - mit zwei Bremsen, damit daraus niemals eine
  Endlosschleife wird (siehe unten).
*/
(function () {
  'use strict';

  if (window.__pawsVariantTilesInit) return;
  window.__pawsVariantTilesInit = true;

  /* Die Ausfuehrungsauswahl. Der aeussere Block traegt die Ueberschrift, der
     innere die Radios - beide Selektoren treffen dieselbe Gruppe, der zweite
     ist der Rueckfall, falls die App die aeussere Huelle einmal umbenennt. */
  var GRUPPEN_SEL = '.tee-available-products, .tee-field--teeinblue-available-prod';
  var RADIO_SEL = '.tee-radio';
  /* Die drei Auswahlgruppen, auf denen ein Bestsellerband stehen darf:
     Ausfuehrung, Groesse, Rahmen bzw. Farbe. Bewusst nicht alle Radios im
     Formular - die Hintergrundfarben und Motivfelder fuehren voellig andere
     Werte, dort waere ein zufaelliger Namensgleichklang moeglich. */
  var BS_SEL = '.tee-available-products .tee-radio, .tee-field--teeinblue-available-prod .tee-radio, .tee-option--size .tee-radio, .tee-option--color .tee-radio';
  /* Die Groessenauswahl - dort und nur dort steht der Differenzbetrag. */
  var GROESSE_SEL = '.tee-option--size';
  var THROTTLE_MS = 200;
  /* Wachstumsbremse: so oft darf die Seite in Folge waehrend eines Laufs
     wachsen, bevor der Beobachter aufgibt. Ein reiner Zaehler pro Sekunde
     reicht nicht - eine gedrosselte Schleife bleibt unter jeder Frequenz-
     schwelle und schiebt die Seite trotzdem Stueck fuer Stueck auf. */
  var WACHSTUM_GRENZE = 4;
  var WACHSTUM_PX = 8;

  var bilder = null;
  var bestseller = null;
  var deltaAn = false;
  /* Beschriftung fuer preisgleiche Groessen, uebersetzt aus paws-texte.js.
     Fehlt sie, bleibt die Zeile in diesem Fall schlicht leer - lieber
     nichts als ein deutscher Satz auf der englischen Seite. */
  var nullText = '';
  var beobachter = null;
  var geplant = 0;
  var wachstumZaehler = 0;

  /* -------------------------------------------------------------------- */
  /* Daten aus Liquid                                                      */
  /* -------------------------------------------------------------------- */
  function bilderLesen() {
    var tag = document.querySelector('script[data-paws-varbilder]');
    if (!tag) return null;
    var roh;
    try {
      roh = JSON.parse(tag.getAttribute('data-paws-varbilder') || '{}');
    } catch (e) {
      return null;
    }
    if (!roh || typeof roh !== 'object') return null;

    var karte = {};
    for (var schluessel in roh) {
      if (!Object.prototype.hasOwnProperty.call(roh, schluessel)) continue;
      /* Reservierte Schluessel steuern nur, WO die Bilder gelten - sie sind
         kein Optionswert und duerfen nie als Kachel landen. */
      if (schluessel.charAt(0) === '_') continue;
      var adresse = adressePruefen(roh[schluessel]);
      if (adresse) karte[normal(schluessel)] = adresse;
    }
    return karte;
  }

  /* Nur echte Bildadressen. Ein Wert aus einem Metafeld ist zwar von uns
     selbst gepflegt, landet hier aber ungeprueft in einem src-Attribut -
     javascript:-Adressen haben dort nichts verloren. */
  function adressePruefen(wert) {
    if (typeof wert !== 'string') return '';
    var t = wert.trim();
    if (!t) return '';
    if (/^https:\/\//i.test(t)) return t;
    if (/^\/\//.test(t)) return 'https:' + t;
    if (/^\//.test(t)) return t;
    return '';
  }

  function normal(wert) {
    return String(wert || '').trim().toLowerCase();
  }

  /*
    Zweitschluessel fuer Groessenangaben, absichtlich nur als RUECKFALL.

    Bei manchen Produkten stehen die Kantenlaengen in der TeeInBlue-Kampagne
    andersherum als in den Shopify-Varianten (Fleecedecke: Kachel
    "200x150 cm", Variante "150x200 cm", Bestsellerliste "100x150 cm").
    Gemeint ist dieselbe Groesse, ein reiner Textvergleich findet sie aber
    nie - Folge waren fehlende Aufpreise, ein fehlendes Bestsellerband und
    damit auch die kleineren Kacheln.

    Zwei mit "x" verbundene Zahlen werden deshalb aufsteigend sortiert und
    Leerzeichen entfernt. Weil ein Produkt Hoch- und Querformat als zwei
    Groessen fuehren kann ("30x40 cm" und "40x30 cm"), darf daraus nie
    allein zugeordnet werden: gesucht wird immer erst der genaue Wert, und
    der Rueckfall zaehlt nur bei GENAU EINEM Treffer (siehe massStelle).
  */
  function massSchluessel(text) {
    var m = String(text || '').replace(/\s+/g, '').match(/^(\d+(?:[.,]\d+)?)x(\d+(?:[.,]\d+)?)(.*)$/);
    if (!m) return '';
    var a = parseFloat(m[1].replace(',', '.'));
    var b = parseFloat(m[2].replace(',', '.'));
    if (!isFinite(a) || !isFinite(b)) return '';
    return (a <= b ? m[1] + 'x' + m[2] : m[2] + 'x' + m[1]) + m[3];
  }

  /* Stelle von "wert" in "liste": genauer Treffer zuerst, sonst der eine
     eindeutige Groessentreffer - bei Mehrdeutigkeit lieber nichts. */
  function massStelle(liste, wert) {
    var i = liste.indexOf(wert);
    if (i !== -1) return i;
    var s = massSchluessel(wert);
    if (!s) return -1;
    var fund = -1;
    for (var k = 0; k < liste.length; k++) {
      if (massSchluessel(liste[k]) !== s) continue;
      if (fund !== -1) return -1;
      fund = k;
    }
    return fund;
  }

  /* Betrag zu einem Kachelwert - nach derselben Regel wie massStelle. */
  function betragZu(karte, wert) {
    if (Object.prototype.hasOwnProperty.call(karte, wert)) return karte[wert];
    var schluessel = Object.keys(karte);
    var i = massStelle(schluessel, wert);
    return i === -1 ? null : karte[schluessel[i]];
  }

  /* -------------------------------------------------------------------- */
  /* Bestseller: Daten aus Liquid                                          */
  /* -------------------------------------------------------------------- */
  /*
    Aufbau: { "_immer": [...], "<ausfuehrung>": [...] }. Werte unter _immer
    gelten dauerhaft, alle uebrigen Schluessel nur, solange genau diese
    Ausfuehrung gewaehlt ist - bei Hochkantformaten heisst dieselbe Groesse
    auf Leinwand anders als auf Poster.

    Verglichen wird gegen Optionswerte, nie gegen Optionsnamen: Shopify
    uebersetzt die Namen ("Groesse" -> "Taille"), die Werte aber nicht.
  */
  function bestsellerLesen() {
    var tag = document.querySelector('script[data-paws-bestseller]');
    if (!tag) return null;
    var roh;
    try {
      roh = JSON.parse(tag.getAttribute('data-paws-bestseller') || 'null');
    } catch (e) {
      return null;
    }
    if (!roh || typeof roh !== 'object') return null;

    var text = (tag.getAttribute('data-paws-bs-text') || '').trim();
    if (text) {
      /* Die Beschriftung steht als CSS-Eigenschaft, nicht als Element in
         jeder Kachel: die App baut das Markup bei jedem Wechsel neu auf und
         wuerde ein eingefuegtes Element jedes Mal wieder wegwerfen.
         JSON.stringify liefert die Anfuehrungszeichen mit, die content:
         verlangt, und entschaerft dabei Anfuehrungszeichen im Text selbst. */
      document.documentElement.style.setProperty('--paws-bs-text', JSON.stringify(text));
    }
    return roh;
  }

  /* Die Beschriftung der gerade gewaehlten Ausfuehrung - sie entscheidet,
     welche der bedingten Listen gilt. */
  function gewaehlteAusfuehrung() {
    var gruppen = document.querySelectorAll(GRUPPEN_SEL);
    for (var g = 0; g < gruppen.length; g++) {
      var aktiv = gruppen[g].querySelector('.tee-radio.active');
      if (aktiv) return normal(beschriftung(aktiv));
    }
    return '';
  }

  function aktiveBsWerte() {
    var raus = [];
    var sammeln = function (liste) {
      if (!liste || typeof liste.length !== 'number') return;
      for (var i = 0; i < liste.length; i++) {
        var n = normal(liste[i]);
        if (n) raus.push(n);
      }
    };
    sammeln(bestseller._immer);
    var f = gewaehlteAusfuehrung();
    if (f) {
      for (var k in bestseller) {
        if (!Object.prototype.hasOwnProperty.call(bestseller, k)) continue;
        /* Schluessel mit fuehrendem Unterstrich steuern nur - sie sind kein
           Optionswert und duerfen nie als Ausfuehrung gelesen werden. */
        if (k.charAt(0) === '_') continue;
        if (normal(k) === f) sammeln(bestseller[k]);
      }
    }
    return raus;
  }

  /* -------------------------------------------------------------------- */
  /* 3. Differenzbetrag auf den Groessenkacheln                            */
  /* -------------------------------------------------------------------- */
  /*
    Was eine andere Groesse gegenueber der GERADE GEWAEHLTEN kostet - genau
    wie updateSizeDeltas() im eigenen Konfigurator. Bezug ist immer die
    aktuelle Auswahl, nicht die guenstigste Variante: der Kunde soll lesen,
    was ihn der Klick kostet.

    Quelle ist das versteckte select[name="id"] des Themes. Seine Optionen
    tragen den Variantentitel ("Poster / 30x40cm / Holzrahmen Schwarz") und
    den Preis als data-price. Damit ist die Differenz die echte Differenz
    zweier Shopify-Varianten - nichts wird geschaetzt, und die Aufschlaege
    der App (Effekte, Motive) fallen heraus, weil sie in beiden Preisen
    gleich stecken.

    Die Position der Groesse im Titel wird NICHT angenommen, sondern gesucht:
    nicht jedes Produkt hat drei Optionen in derselben Reihenfolge.
  */
  function centsAusText(roh) {
    var s = String(roh || '').replace(/\s/g, '').replace(/[^\d.,]/g, '');
    if (!s) return null;
    /* Das letzte Trennzeichen ist der Dezimalpunkt, wenn hoechstens zwei
       Ziffern folgen - sonst ist es ein Tausendertrenner. Nur so lassen sich
       "19,95 EUR" und "1.234,50 EUR" mit derselben Regel lesen, ohne die
       Schreibweise der jeweiligen Sprache zu kennen. */
    var i = Math.max(s.lastIndexOf(','), s.lastIndexOf('.'));
    var bruch = '';
    var ganz = s;
    if (i !== -1 && /^\d{1,2}$/.test(s.slice(i + 1))) {
      ganz = s.slice(0, i);
      bruch = s.slice(i + 1);
      if (bruch.length === 1) bruch += '0';
    }
    ganz = ganz.replace(/[.,]/g, '');
    if (!/^\d+$/.test(ganz)) return null;
    return parseInt(ganz, 10) * 100 + (bruch ? parseInt(bruch, 10) : 0);
  }

  function euroText(cents) {
    var betrag = Math.abs(cents) / 100;
    var text;
    try {
      text = betrag.toLocaleString(document.documentElement.lang || 'de', {
        style: 'currency',
        currency: 'EUR',
        /* Runde Betraege ohne Nachkommastellen: "+ 20 EUR" liest sich auf
           einer 88 Pixel breiten Kachel deutlich schneller als "+ 20,00 EUR". */
        minimumFractionDigits: Math.abs(cents) % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      });
    } catch (e) {
      text = betrag.toFixed(2).replace('.', ',') + ' \u20AC';
    }
    return (cents < 0 ? '\u2212 ' : '+ ') + text;
  }

  function optionsTeile(opt) {
    var roh = (opt.textContent || '').split('/');
    if (roh.length < 2) return null;
    var teile = [];
    for (var i = 0; i < roh.length; i++) teile.push(normal(roh[i]));
    return teile;
  }

  /* Alles, was der Besucher sichtbar ausgewaehlt hat. Von den beiden
     Rahmenbloecken im DOM zaehlt nur der eingeblendete. */
  function sichtbareAuswahl() {
    var werte = [];
    var f = gewaehlteAusfuehrung();
    if (f) werte.push(f);
    var gruppen = document.querySelectorAll('.tee-option--size, .custom-frame-wrapper');
    for (var g = 0; g < gruppen.length; g++) {
      if (gruppen[g].offsetParent === null) continue;
      var inp = gruppen[g].querySelector('input:checked');
      if (inp && inp.value) werte.push(normal(inp.value));
    }
    return werte;
  }

  /*
    Die App setzt select[name="id"] beim Wechsel kurzzeitig auf einen
    veralteten oder gar unbekannten Stand. Ein daraus gerechneter Betrag
    waere schlicht falsch. Deshalb muss JEDER sichtbar gewaehlte Wert im
    Titel der Bezugsvariante vorkommen - sonst bleibt die Zeile leer.
    Lieber keine Angabe als eine falsche.
  */
  function bezugsOption(sel) {
    var kandidaten = [];
    if (sel.selectedOptions && sel.selectedOptions.length) kandidaten.push(sel.selectedOptions[0]);
    if (sel.selectedIndex >= 0 && sel.options[sel.selectedIndex]) kandidaten.push(sel.options[sel.selectedIndex]);
    var auswahl = sichtbareAuswahl();
    for (var k = 0; k < kandidaten.length; k++) {
      var teile = optionsTeile(kandidaten[k]);
      var cents = centsAusText(kandidaten[k].getAttribute('data-price'));
      if (!teile || cents === null) continue;
      var passt = true;
      for (var a = 0; a < auswahl.length; a++) {
        if (massStelle(teile, auswahl[a]) === -1) { passt = false; break; }
      }
      if (passt) return { teile: teile, cents: cents };
    }
    return null;
  }

  function deltasSetzen() {
    var gruppe = document.querySelector(GROESSE_SEL);
    if (!gruppe) return;
    var radios = gruppe.querySelectorAll(RADIO_SEL);
    if (!radios.length) return;

    var karte = null;
    var sel = document.querySelector('select[name="id"]');
    var gewaehlt = gruppe.querySelector('input:checked');
    var bezug = sel ? bezugsOption(sel) : null;
    /* An welcher Stelle des Variantentitels steht die Groesse? Der gerade
       gewaehlte Kachelwert verraet es - und beweist zugleich, dass Select
       und Kacheln denselben Stand meinen. */
    var stelle = (bezug && gewaehlt) ? massStelle(bezug.teile, normal(gewaehlt.value)) : -1;

    if (stelle !== -1) {
      karte = {};
      for (var o = 0; o < sel.options.length; o++) {
        var teile = optionsTeile(sel.options[o]);
        if (!teile || teile.length !== bezug.teile.length) continue;
        var passt = true;
        for (var p = 0; p < teile.length; p++) {
          /* Nur die Groesse darf abweichen: Ausfuehrung und Rahmen bleiben,
             wie sie sind - sonst waere die Differenz nicht die, die der
             Klick auf diese Kachel tatsaechlich ausloest. */
          if (p !== stelle && teile[p] !== bezug.teile[p]) { passt = false; break; }
        }
        if (!passt) continue;
        var c = centsAusText(sel.options[o].getAttribute('data-price'));
        if (c === null) continue;
        /* Zwei Eintraege unter demselben Groessenteil darf es bei sonst
           gleichem Titel nicht geben - dann waere keine Zuordnung mehr
           belastbar. Lieber keine Angabe als eine falsche. */
        if (Object.prototype.hasOwnProperty.call(karte, teile[stelle])) { karte = null; break; }
        karte[teile[stelle]] = c - bezug.cents;
      }
    }

    for (var i = 0; i < radios.length; i++) {
      var label = radios[i].querySelector('.tee-radio-label');
      if (!label) continue;
      var inp = radios[i].querySelector('input');
      var wert = inp ? normal(inp.value) : '';
      var d = karte ? betragZu(karte, wert) : null;
      /* Dieselben drei Zustaende wie updateSizeDeltas() im eigenen
         Konfigurator - inklusive der Farben, die daran haengen: Aufpreis
         dunkelneutral, kleinere Groesse zurueckhaltend grau, gleicher
         Preis als gruene Pille. Ohne diese Klassen sah jeder Betrag
         gleich wichtig aus. */
      var txt = '';
      var klasse = '';
      if (d !== null) {
        if (d !== 0) {
          txt = euroText(d);
          klasse = d > 0 ? 'is-plus' : 'is-minus';
        } else if (!inp || !inp.checked) {
          /* Gleicher Preis bei anderer Groesse ist eine Nachricht wert.
             An der gewaehlten Kachel selbst waere "ohne Aufpreis" ein
             Selbstbezug - dort bleibt die Zeile leer. */
          txt = nullText;
          klasse = txt ? 'is-null' : '';
        }
      }
      var span = label.querySelector('.paws-tib-diff');
      if (!span) {
        /* Ohne Betraege fuer dieses Produkt wird gar nichts erst angelegt.
           Gibt es sie, bekommt JEDE Kachel die Zeile - auch die gewaehlte
           und jede preisgleiche. Sonst waeren die Kacheln einer Zeile
           unterschiedlich hoch (gemessen 40 gegen 52 Pixel). */
        if (!karte) continue;
        span = document.createElement('span');
        span.className = 'paws-tib-diff';
        /* Ans Ende des Labels: Vue vergleicht seine Kinder von vorne, ein
           angehaengter fremder Knoten ueberlebt den naechsten Neuaufbau. */
        label.appendChild(span);
      }
      /* Erst pruefen, dann schreiben - sonst loest der eigene Eingriff die
         naechste Beobachtung aus. Die Klasse steht zusaetzlich als
         data-Attribut, damit der Vergleich ohne classList-Gerechne
         auskommt. */
      if (span.textContent !== txt) span.textContent = txt;
      if (span.getAttribute('data-state') !== klasse) {
        span.setAttribute('data-state', klasse);
        span.className = 'paws-tib-diff' + (klasse ? ' ' + klasse : '');
      }
    }
    /* Die Zeile darf nur Platz belegen, wenn es auch etwas anzuzeigen gibt.
       Der Schalter haengt bewusst an <html> und nicht am Feld selbst: die
       App schreibt das class-Attribut ihrer eigenen Knoten staendig neu, an
       <html> ruehrt sie nie - sonst zuckte die Kachelhoehe bei jedem Klick. */
    var an = !!karte;
    var w = document.documentElement;
    if (w.classList.contains('paws-tib-hasdiff') !== an) w.classList.toggle('paws-tib-hasdiff', an);
  }

  /*
    Nur eine Klasse - die Auswahl, ihre Reihenfolge und der Warenkorb
    bleiben unberuehrt. Das Band ist reine Auszeichnung, keine Entscheidung.

    Groesse und Rahmen tragen den Optionswert im value des <input>. Die
    Ausfuehrung nicht: dort steht eine App-interne Nummer, der lesbare Wert
    steht nur in der Beschriftung. Deshalb zaehlt beides als Treffer.
  */
  function bestsellerSetzen() {
    if (!bestseller) return;
    var werte = aktiveBsWerte();
    var radios = document.querySelectorAll(BS_SEL);
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      var inp = r.querySelector('input');
      var treffer = false;
      if (inp && massStelle(werte, normal(inp.value)) !== -1) treffer = true;
      if (!treffer && massStelle(werte, normal(beschriftung(r))) !== -1) treffer = true;
      /* Geschrieben wird nur, was fehlt: sonst loest der eigene Eingriff
         die naechste Beobachtung aus. */
      if (treffer !== r.classList.contains('paws-tib-bs')) r.classList.toggle('paws-tib-bs', treffer);
    }
  }

  /* -------------------------------------------------------------------- */
  /* Kacheln setzen                                                        */
  /* -------------------------------------------------------------------- */
  function beschriftung(radio) {
    var label = radio.querySelector('.tee-radio-label');
    if (!label) return '';
    var span = label.querySelector('span');
    return (span ? span.textContent : label.textContent) || '';
  }

  function kachelnSetzen() {
    if (!bilder) return;
    var gruppen = document.querySelectorAll(GRUPPEN_SEL);
    for (var g = 0; g < gruppen.length; g++) {
      var radios = gruppen[g].querySelectorAll(RADIO_SEL);
      /* Eine einzige Ausfuehrung ist keine Auswahl - eine Kachel, die man
         nicht wechseln kann, kostet nur Platz. */
      if (radios.length < 2) continue;

      for (var i = 0; i < radios.length; i++) {
        var radio = radios[i];
        var label = radio.querySelector('.tee-radio-label');
        if (!label) continue;

        var adresse = bilder[normal(beschriftung(radio))];
        if (!adresse) continue;

        /* Die App schreibt das class-Attribut des Radios bei jedem Wechsel
           komplett neu und wirft unsere Markierung dabei weg. Deshalb wird
           sie bei JEDEM Durchlauf wieder gesetzt - und zwar bevor weiter
           unten wegen eines bereits passenden Bildes abgekuerzt wird.
           Geschrieben wird nur, was fehlt: sonst loest der eigene Eingriff
           die naechste Beobachtung aus. */
        if (!radio.classList.contains('paws-tib-tile')) radio.classList.add('paws-tib-tile');
        if (!gruppen[g].classList.contains('paws-tib-tiles')) gruppen[g].classList.add('paws-tib-tiles');

        var bild = label.querySelector('.paws-tib-tile__bild');
        if (bild && bild.getAttribute('src') === adresse) continue;
        if (!bild) {
          bild = document.createElement('img');
          bild.className = 'paws-tib-tile__bild';
          bild.setAttribute('alt', '');
          bild.setAttribute('aria-hidden', 'true');
          /* Kein loading="lazy": die Kacheln stehen im geoeffneten
             Personalisierer immer im Blickfeld, und der Browser hat das
             Nachladen im Testlauf schlicht nicht angestossen. */
          bild.setAttribute('decoding', 'async');
          /* Vor den Text: Bild oben, Beschriftung darunter. */
          label.insertBefore(bild, label.firstChild);
        }
        bild.setAttribute('src', adresse);
      }
    }
  }

  /*
    Nur die Markierungen, dafuer synchron und ohne Drossel.

    Die App schreibt das class-Attribut des Radios bei jedem Auswahlwechsel
    neu und wirft unsere Markierung dabei weg. Kaeme sie erst mit dem
    gedrosselten Durchlauf zurueck, waere die Kachel rund 200 Millisekunden
    lang ungestaltet - lange genug, dass das Bild sichtbar auf Spaltenbreite
    aufgeht. Der Rueckruf des Beobachters laeuft noch vor dem naechsten
    Bildaufbau, hier gesetzt sieht der Besucher den Zwischenzustand nie.

    Bewusst ohne DOM-Aufbau und ohne Groessenabfrage - beides gehoert in den
    gedrosselten Durchlauf, damit dieser Weg billig bleibt. Geschrieben wird
    wieder nur, was fehlt, sonst loest der eigene Eingriff die naechste
    Beobachtung aus.
  */
  function markenSetzen() {
    var vorhandene = document.querySelectorAll('.paws-tib-tile__bild');
    for (var i = 0; i < vorhandene.length; i++) {
      var radio = vorhandene[i].closest(RADIO_SEL);
      if (!radio) continue;
      if (!radio.classList.contains('paws-tib-tile')) radio.classList.add('paws-tib-tile');
      var gruppe = radio.closest(GRUPPEN_SEL);
      if (gruppe && !gruppe.classList.contains('paws-tib-tiles')) gruppe.classList.add('paws-tib-tiles');
    }
    /* Aus demselben Grund hier und nicht im gedrosselten Durchlauf: mit dem
       class-Attribut wirft die App auch das Bestsellerband weg. Der Aufwand
       ist derselbe wie oben - ein Vergleich und hoechstens eine Klasse. */
    bestsellerSetzen();
  }

  /* -------------------------------------------------------------------- */
  /* Beobachtung                                                           */
  /* -------------------------------------------------------------------- */
  function planen() {
    if (geplant) return;
    geplant = window.setTimeout(function () {
      geplant = 0;
      var vorher = document.documentElement.scrollHeight;
      kachelnSetzen();
      bestsellerSetzen();
      if (deltaAn) deltasSetzen();
      var nachher = document.documentElement.scrollHeight;
      /* Beim ersten Setzen wachsen die Kacheln erwartungsgemaess - das ist
         genau einmal richtig. Wiederholt sich es, laeuft etwas im Kreis. */
      if (nachher - vorher > WACHSTUM_PX) {
        wachstumZaehler++;
        if (wachstumZaehler >= WACHSTUM_GRENZE && beobachter) {
          beobachter.disconnect();
          beobachter = null;
        }
      } else {
        wachstumZaehler = 0;
      }
    }, THROTTLE_MS);
  }

  function starten() {
    bilder = bilderLesen();
    if (bilder) {
      var leer = true;
      for (var k in bilder) { if (Object.prototype.hasOwnProperty.call(bilder, k)) { leer = false; break; } }
      if (leer) bilder = null;
    }
    bestseller = bestsellerLesen();
    /* Der Differenzbetrag braucht keine Pflegedaten - er rechnet aus den
       Varianten, die ohnehin auf der Seite stehen. Das Liquid setzt den
       Schalter nur bei Produkten mit mehr als einer Variante. */
    var tag = document.querySelector('script[data-paws-delta]');
    deltaAn = !!tag && tag.getAttribute('data-paws-delta') === '1';
    nullText = tag ? (tag.getAttribute('data-paws-delta-zero') || '') : '';
    /* Alle drei Aufgaben teilen sich einen Beobachter. Ohne Daten fuer
       mindestens eine von ihnen gibt es nichts zu tun. */
    if (!bilder && !bestseller && !deltaAn) return;

    kachelnSetzen();
    bestsellerSetzen();
    if (deltaAn) deltasSetzen();

    var wurzel = document.querySelector('#teeinblue-form') || document.body;
    if (!wurzel || typeof MutationObserver !== 'function') return;
    beobachter = new MutationObserver(function () {
      markenSetzen();
      planen();
    });
    /* Auch auf class hoeren: der Wechsel der Auswahl aendert nur ein
       Attribut, nicht den Baum - ohne diesen Filter bliebe die Kachel nach
       dem ersten Klick ungestaltet zurueck. */
    beobachter.observe(wurzel, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten, { once: true });
  } else {
    starten();
  }
})();
